module.exports = __webpack_public_path__ + "static/img/a072.9e9e308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a072.jpg
// module id = ClHr
// module chunks = 0